var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uploader-wrap",attrs:{"id":_vm.id}},[_c('p',{staticClass:"action-buttons"},[_c('button',{staticClass:"change-image",on:{"click":_vm.wpMediaInit}},[_vm._v("Change Image")]),_vm._v(" "),_c('button',{staticClass:"remove-image",on:{"click":_vm.removeMedia}},[_vm._v("Remove")])]),_vm._v(" "),(_vm.imgSrc !== '')?_c('img',{attrs:{"src":_vm.imgSrc}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71f57a30","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/fields/uploader.vue
// module id = 78
// module chunks = 0